import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Saisine, SaisineStatus} from './saisine.model';
import {MasterProposal, PropositionStatus} from '../master-proposal/master-proposal.model';
import {Principal} from '../../shared/auth/principal.service';
import {MasterProposalService} from '../master-proposal/master-proposal.service';
import {UtilsService} from '../../shared/utils/utils.service';
import {MasterService} from '../master/master.service';
import {isNullOrUndefined} from 'util';
import {AlertService} from 'ng-jhipster';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
/**
 * Created by A665445 on 26/05/2017.
 */
@Component({
    selector: 'jhi-saisine-search-solutions-student',
    templateUrl: './saisine-search-solutions-student.component.html'
})
export class SaisineSearchSolutionsStudentComponent implements OnInit {
    @Input() saisine: Saisine;

    @Output() saisineChange = new EventEmitter();

    // Table search solutions
    @ViewChild('dtSearchSolutionsStudent') dtSearchSolutionsStudent;
    multiSortMetaDtSearchSolutionsStudent: any[];

    statusOnAccepted: any[];

    hasEnougthProposal = false;
    masterProposalsInCart: MasterProposal[];
    masterProposalsFiltered: MasterProposal[];

    isSaving: boolean;
    constructor(public principal: Principal,
                private masterProposalService: MasterProposalService,
                public masterService: MasterService,
                public utilsService: UtilsService,
                private alertService: AlertService,
                private modalService: NgbModal,
    ) {}

    ngOnInit(): void {
        this.statusOnAccepted = [PropositionStatus.ACCEPTED];
        this.masterProposalsInCart = [];
        this.masterProposalsFiltered = this.saisine.masterProposals.filter(mp => mp.status === PropositionStatus.ACCEPTED);
    }

    addMasterProposalToCart(mp: MasterProposal) {
        mp.master.inCart = true;
        this.masterProposalsInCart.push(mp);
    }

    isAtLeastOneSelected(): boolean {
        if (this.masterProposalsInCart.length > 0) {
            return this.masterProposalsInCart.map(mp => mp.master.selected === true).reduce((acc, curr) => acc || curr);
        } else {
            return false;
        }
    }

    submitCart(popUpContent) {
        this.isSaving = true;

        if (this.saisine.hasStatus(SaisineStatus.CHECKED)) {
            let trasnsmittedMp = this.saisine.masterProposals.filter(mp => mp.status === PropositionStatus.TRANSMITTED || mp.status === PropositionStatus.REFUSED).length;
            let trasnsmittedMpc = this.masterProposalsInCart.filter(mpc => mpc.master.selected).length;

            if (trasnsmittedMp < 3) {
                (trasnsmittedMp + trasnsmittedMpc) >= 3 ? this.hasEnougthProposal = true : this.hasEnougthProposal = false ;
                this.open(popUpContent);
            }
        }
    }

    // this binding
    onSaveSuccess = () => {
        this.isSaving = false;

        // Suppression des master proposal du panier
        this.masterProposalsFiltered.forEach(mp => {
            if (!isNullOrUndefined(mp.master.inCart)) {
                mp.master.inCart = false;
            }
        });
        this.masterProposalsInCart = [];
        this.saisineChange.emit();
    }

    // this binding
    onSaveError = (error) => {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    // modal
    open(popUpContent) {
            this.modalService.open(popUpContent).result.then((result) => {
                this.masterProposalService.updateMPToTransmitted(this.saisine.id, this.masterProposalsInCart.filter(mp => mp.master.selected)).subscribe(this.onSaveSuccess, this.onSaveError);
            }, (reason) => {
                this.isSaving = false;
            });
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-search-solutions-student.component.ts